<template>
    <div v-if="hasMounted">
        <h6 class="mb-2">New suppliers that will be added</h6>

        <webix-ui :config="ui" v-model="suppliers_to_add"></webix-ui>
        <div id="suppliersToAddTablePaging"></div>
    </div>
</template>

<script>
import { suppliersComputed, suppliersMethods } from "@/state/helpers";

export default {
    components: {},
    data: () => ({
        hasMounted: false,
        resize_event: null,
    }),
    computed: {
        ...suppliersComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "suppliersToAddTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "suppliersTableHoverRow",

                minHeight: 60,
                minColumnWidth: 120,
                rowHeight: 35,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                editable: true,

                // pager: {
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "suppliersToAddTablePaging",
                //     css: { width: "100% !important" },
                //     size: 15,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "supplier_name",
                        header: ["Supplier Name"],
                        tooltip: false,
                        // editor: "text",
                        fillspace: 1,
                    },
                    {
                        id: "supplier_no",
                        header: ["Contact No."],
                        fillspace: 1,
                    },
                    {
                        id: "contact_no",
                        header: ["Contact No."],
                        fillspace: 1,
                    },
                    {
                        id: "contact_person",
                        header: ["Contact Person"],
                        fillspace: 1,
                    },
                    {
                        id: "email",
                        header: ["Email"],
                        fillspace: 1,
                    },
                    {
                        id: "address",
                        header: ["Address"],
                        fillspace: 1,
                    },
                ],
                ready() {
                    // el.resize_event = window.webix.event(window, "resize", function() {
                    //     el.$nextTick(() => {
                    //         window.webix.$$(el.ui.id).refresh();
                    //     });
                    // });
                },
                on: {},

                onClick: {
                    //eslint-disable-next-line
                    qcAction: function(id, e, trg) {},
                    //eslint-disable-next-line
                    certificateListAction: function(id, e, trg) {},
                },
            };

            //pager
            if (this.suppliers_to_add.length > 15) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "suppliersToAddTablePaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                };
            }

            return ui;
        },
    },
    methods: {
        ...suppliersMethods,
    },
    mounted() {
        setTimeout(() => {
            this.hasMounted = true;
        }, 100);
    },
};
</script>

<style lang="scss">
.suppliersTableHoverRow {
    background: #f0dcb6;
    cursor: text;
}
</style>
